import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-contenido" }
const _hoisted_3 = { class: "modal-titulo" }
const _hoisted_4 = {
  key: 0,
  class: "form-group"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 0,
  class: "campo-error"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "radio-grupo" }
const _hoisted_11 = { class: "radio-opcion" }
const _hoisted_12 = { class: "radio-opcion" }
const _hoisted_13 = {
  key: 0,
  class: "campo-error"
}
const _hoisted_14 = {
  key: 1,
  class: "form-group"
}
const _hoisted_15 = {
  key: 0,
  class: "campus-chips"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "campus-vacio"
}
const _hoisted_18 = {
  key: 2,
  class: "campus-agregar"
}
const _hoisted_19 = ["value"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 2,
  class: "error-global"
}
const _hoisted_22 = { class: "botones" }
const _hoisted_23 = ["disabled"]

import { ref, watch, computed } from 'vue'
import type { Programa } from '@/interfaces/Programa'
import type { Campus } from '@/interfaces/Campus'


export default /*@__PURE__*/_defineComponent({
  __name: 'AreaModal',
  props: {
    visible: { type: Boolean },
    area: {},
    opcionesPlanas: {},
    opcionesCampus: {}
  },
  emits: ["cancelar", "guardar"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

/**
 * Alta y edición de un área.
 *
 * Cambiar el padre MUEVE el área con toda su descendencia; el backend rechaza el
 * movimiento si formaría un ciclo.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const nombre            = ref('')
const tipo              = ref('')
const nivel             = ref<'pregrado' | 'posgrado' | null>(null)
const padreSeleccionado = ref<number | null>(null)
const errores           = ref<Record<string, string>>({})
const errorGlobal       = ref('')
const guardando         = ref(false)

// Lista local de campus asignados en el modal
const campusSeleccionados = ref<{ id_campus: number; nombre: string }[]>([])
const campusParaAgregar   = ref<number | null>(null)

const esEdicion = computed(() => !!props.area?.id_programa)

// Campus que aún no están en la lista seleccionada
const campusDisponibles = computed(() =>
  (props.opcionesCampus ?? []).filter(
    c => !campusSeleccionados.value.some(s => s.id_campus === c.id_campus)
  )
)

watch(
  () => props.visible,
  (v) => {
    if (v) {
      nombre.value            = props.area?.nombre   ?? ''
      tipo.value              = props.area?.tipo     ?? ''
      nivel.value             = props.area?.nivel    ?? null
      padreSeleccionado.value = props.area?.padre_id ?? null
      // Pre-cargar campus actuales del área en modo edición
      campusSeleccionados.value = (props.area?.campus ?? []).map(c => ({
        id_campus: c.id_campus,
        nombre:    c.nombre
      }))
      campusParaAgregar.value = null
      errores.value           = {}
      errorGlobal.value       = ''
      guardando.value         = false
    }
  }
)

function agregarCampus() {
  if (campusParaAgregar.value === null) return
  const campus = props.opcionesCampus?.find(c => c.id_campus === campusParaAgregar.value)
  if (!campus) return
  campusSeleccionados.value.push({ id_campus: campus.id_campus, nombre: campus.nombre })
  campusParaAgregar.value = null
}

function quitarCampus(idCampus: number) {
  campusSeleccionados.value = campusSeleccionados.value.filter(c => c.id_campus !== idCampus)
}

function confirmar() {
  errores.value = {}
  errorGlobal.value = ''
  if (!nombre.value.trim()) {
    errores.value.nombre = 'El nombre es obligatorio.'
    return
  }
  if (tipo.value.toLowerCase().trim() === 'programa' && !nivel.value) {
    errores.value.nivel = 'El nivel es obligatorio para áreas de tipo Programa.'
    return
  }

  const esPrograma = tipo.value.toLowerCase().trim() === 'programa'
  const facultad = esPrograma && nivel.value
    ? (props.opcionesPlanas.find(o => o.id === padreSeleccionado.value)?.nombre ?? null)
    : null

  emit('guardar', {
    nombre:     nombre.value.trim(),
    tipo:       tipo.value.trim() || undefined,
    nivel:      esPrograma ? (nivel.value || null) : null,
    padre_id:   padreSeleccionado.value,
    facultad:   facultad || null,
    campus_ids: campusSeleccionados.value.map(c => c.id_campus)
  })
}

__expose({
  setGuardando: (v: boolean) => { guardando.value = v },
  setError: (msg: string) => { errorGlobal.value = msg }
})

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(esEdicion.value ? 'Editar Área' : 'Nueva Área'), 1),
          (_ctx.opcionesPlanas.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("label", null, _toDisplayString(nivel.value ? 'Facultad' : 'Área superior jerárquica'), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((padreSeleccionado).value = $event)),
                  class: "input-select"
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("option", { value: null }, "— Ninguna —", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opcionesPlanas, (op) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: op.id,
                      value: op.id
                    }, _toDisplayString(op.label), 9, _hoisted_5))
                  }), 128))
                ], 512), [
                  [_vModelSelect, padreSeleccionado.value]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Nombre del área", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nombre).value = $event)),
              type: "text",
              placeholder: "Ej. Facultad de Ingeniería",
              class: "input-campo",
              onKeyup: _withKeys(confirmar, ["enter"])
            }, null, 544), [
              [_vModelText, nombre.value]
            ]),
            (errores.value.nombre)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errores.value.nombre), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Tipo de área", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tipo).value = $event)),
              type: "text",
              placeholder: "ej: Facultad, Programa, Administrativa, Investigación",
              class: "input-campo"
            }, null, 512), [
              [_vModelText, tipo.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[12] || (_cache[12] = _createElementVNode("label", null, [
              _createTextVNode("Nivel "),
              _createElementVNode("span", { class: "nota-campo" }, "(solo aplica para programas)")
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((nivel).value = $event)),
                  value: "pregrado"
                }, null, 512), [
                  [_vModelRadio, nivel.value]
                ]),
                _cache[10] || (_cache[10] = _createTextVNode(" Pregrado "))
              ]),
              _createElementVNode("label", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((nivel).value = $event)),
                  value: "posgrado"
                }, null, 512), [
                  [_vModelRadio, nivel.value]
                ]),
                _cache[11] || (_cache[11] = _createTextVNode(" Posgrado "))
              ])
            ]),
            (errores.value.nivel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errores.value.nivel), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.opcionesCampus && _ctx.opcionesCampus.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[14] || (_cache[14] = _createElementVNode("label", null, "Campus asignados", -1)),
                (campusSeleccionados.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campusSeleccionados.value, (c) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: c.id_campus,
                          class: "campus-chip"
                        }, [
                          _createTextVNode(_toDisplayString(c.nombre) + " ", 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "chip-quitar",
                            onClick: ($event: any) => (quitarCampus(c.id_campus))
                          }, "×", 8, _hoisted_16)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_17, "Sin campus asignado")),
                (campusDisponibles.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((campusParaAgregar).value = $event)),
                        class: "input-select campus-select"
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("option", { value: null }, "— Agregar campus —", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campusDisponibles.value, (c) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: c.id_campus,
                            value: c.id_campus
                          }, _toDisplayString(c.nombre), 9, _hoisted_19))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, campusParaAgregar.value]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-agregar",
                        onClick: agregarCampus,
                        disabled: campusParaAgregar.value === null
                      }, " Agregar ", 8, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (errorGlobal.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(errorGlobal.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              class: "btn salir",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('cancelar')), ["stop"]))
            }, "Cancelar"),
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: guardando.value,
              onClick: _withModifiers(confirmar, ["stop"])
            }, _toDisplayString(guardando.value ? 'Guardando...' : (esEdicion.value ? 'Guardar cambios' : 'Crear área')), 9, _hoisted_23)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})